import React from "react";
import ShowTeamList from "../ShareTeam/ShareTeamList.js";
import ButtonWithProgress from "components/ButtonWithProgress";
import PollReasonInputs from "components/CustomInput/PollReasonInput.js";
import MediaPreviewName from "components/MediaPreview/MediaPreviewName";
import CustomTextArea from "components/CustomTextArea";
import DatePicker from "components/DatePicker";
import Loader from "components/Loader";
import MediaUpload from "components/MediaUpload";
import Button from "components/CustomButton";
import ChatGptAssistModal from "components/ChatGptAssistModal.js";

const AddEditForm = ({
  formik,
  addMoreOptions,
  selectTeams,
  uploadProgress,
  loading,
  teamError,
  onAttachmentSelected,
  clearAttachment,
  selectedTeams,
  showTeams,
  setValue,
  singleTeam = false,
}) => {
  return (
    <form noValidate onSubmit={formik.handleSubmit}>
      <div className="row modalInputGap">
        <>
          <label
            className={
              !formik.values.showTeamModel ? "poll-form-label" : "display-none"
            }
          >
            Question for the Poll?
          </label>
          <div
            className={
              !formik.values.showTeamModel ? "form-group" : "display-none"
            }
          >
            <ChatGptAssistModal setValue={setValue} />
            <CustomTextArea
              errorClass="errorMessage"
              textColor={"black"}
              textAreaClass="form-control border-radius poll-text-area"
              formik={formik}
              placeholder="Write Here"
              fieldName={"question"}
              rows={3}
            />
          </div>
          <div
            className={
              !formik.values.showTeamModel ? "form-group" : "display-none"
            }
          >
            <label className="poll-form-label">When this poll will end?</label>
            <DatePicker
              inputClass="form-control border-radius"
              value={formik.values.end_time}
              inputProps={{
                error:
                  !!formik.errors.end_time &&
                  !!formik.touched.end_time &&
                  formik.errors.end_time,
              }}
              onChange={(value) => {
                formik.setFieldValue("end_time", value);
              }}
              minDate={new Date()}
            />
          </div>
          <label
            className={
              !formik.values.showTeamModel ? "poll-form-label" : "display-none"
            }
          >
            Add Image or Record Audio/Video for Better Effectiveness
          </label>
          <div
            className={
              !formik.values.showTeamModel ? "form-group" : "display-none"
            }
          >
            {!!formik.values.attachment && (
              <MediaPreviewName
                attachment={formik.values.attachment}
                clearAttachment={clearAttachment}
              />
            )}
            {!formik.values.attachment ? (
              <MediaUpload
                type="image"
                showSelectors={false}
                onChange={onAttachmentSelected}
                accepted={[".png", ".jpg", ".jpeg", ".mp4", ".mp3"]}
              />
            ) : null}
          </div>
          <div
            className={
              !formik.values.showTeamModel ? "pollReason" : "display-none"
            }
          >
            <PollReasonInputs formik={formik} />
          </div>
          <div
            className={
              !formik.values.showTeamModel ? "form-group" : "display-none"
            }
          >
            <Button
              type="button"
              buttonClass="btn btn-outline-warning poll-add-more-option-button full_w"
              name={"+ Add another response"}
              disabled={
                (formik.values.addOptions || []).length === 5 ||
                (loading && true)
              }
              onClick={addMoreOptions}
            />
          </div>
          {!singleTeam && (
            <>
              <div
                className={
                  formik.values.showTeamModel ? "pollTeams" : "display-none"
                }
              >
                <ShowTeamList
                  formik={formik}
                  selectTeams={selectTeams}
                  selectedTeams={selectedTeams}
                  disabled={loading && true}
                />
              </div>
              <div className="errorMessage">{teamError}</div>
            </>
          )}
        </>
        <div className="form-group">
          {!formik.values.showTeamModel && !singleTeam ? (
            <Button
              buttonClass={
                !formik.values.showTeamModel
                  ? "btn grad_btn full_w"
                  : "display-none"
              }
              name={"Create Now"}
              type={"button"}
              onClick={showTeams}
            />
          ) : formik.values.attachment === null ? (
            <button
              className={
                formik.values.showTeamModel || singleTeam
                  ? "btn grad_btn full_w"
                  : "display-none"
              }
              type={"submit"}
              disabled={loading && true}
            >
              {!loading ? (
                singleTeam ? (
                  "Create Now"
                ) : (
                  "Share"
                )
              ) : (
                <Loader width={40} height={40} />
              )}
            </button>
          ) : (
            <ButtonWithProgress
              buttonWithProgressClass={
                formik.values.showTeamModel || singleTeam
                  ? "btn grad_btn full_w"
                  : "display-none"
              }
              initialText={singleTeam ? "Create Now" : "Share"}
              isSubmitting={loading && true}
              progress={Math.ceil(uploadProgress)}
              message={"Creating Poll"}
              overlay={false}
              type={"submit"}
              disabled={loading && true}
            />
          )}
        </div>
      </div>
    </form>
  );
};
export default AddEditForm;
